module.exports = __webpack_public_path__ + "static/media/pages.a649c770.svg";